import { SvgIcon, SvgIconProps } from '@mui/material';

const PLetterIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.625 8.50001V5.58334C6.625 5.47283 6.6689 5.36685 6.74704 5.28871C6.82518 5.21057 6.93116 5.16667 7.04167 5.16667H9.54167C9.87319 5.16667 10.1911 5.29837 10.4256 5.53279C10.66 5.76721 10.7917 6.08515 10.7917 6.41667V7.25001C10.7917 7.58153 10.66 7.89947 10.4256 8.13389C10.1911 8.36831 9.87319 8.50001 9.54167 8.50001H6.625ZM6.625 8.50001V11.8333"
          stroke="var(--mui-palette-text-secondary)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1 6.33333C1 4.46667 1 3.53333 1.36333 2.82C1.68291 2.19282 2.19282 1.68291 2.82 1.36333C3.53333 1 4.46667 1 6.33333 1H10.6667C12.5333 1 13.4667 1 14.18 1.36333C14.8072 1.68291 15.3171 2.19282 15.6367 2.82C16 3.53333 16 4.46667 16 6.33333V10.6667C16 12.5333 16 13.4667 15.6367 14.18C15.3171 14.8072 14.8072 15.3171 14.18 15.6367C13.4667 16 12.5333 16 10.6667 16H6.33333C4.46667 16 3.53333 16 2.82 15.6367C2.19282 15.3171 1.68291 14.8072 1.36333 14.18C1 13.4667 1 12.5333 1 10.6667V6.33333Z"
          stroke="var(--mui-palette-text-secondary)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export default PLetterIcon;
